import { axios } from "@app/app/services/axios";

export const tryBookingWhizzLogin = async (propertyId: string, email: string, password: string): Promise<any> => {
    const response = await axios.post<any>(`vendor-loyalty/${propertyId}/booking-whizz/login `, {
        email,
        password,
    });

    return response.data;
};

export const getBookingWhizzMemberDetails = async (propertyId: string, accessToken: string): Promise<any> => {
    const response = await axios.get<any>(`vendor-loyalty/${propertyId}/booking-whizz/member_details `, {
        headers: {
            "Public-Token": accessToken,
        },
    });

    return response.data;
};

export const registerBookingWhizzMember = async (
    propertyId: string,
    email: string,
    password: string,
    title: string,
    firstName: string,
    lastName: string,
    dateOfBirth: string,
    phoneNumber: string,
    mobileCode: string,
    countryCode: string,
    address: string
): Promise<any> => {
    const response = await axios.post<any>(`vendor-loyalty/${propertyId}/booking-whizz/register `, {
        email,
        password,
        title,
        first_name: firstName,
        last_name: lastName,
        date_of_birth: dateOfBirth,
        phone_number: phoneNumber,
        mobile_code: mobileCode,
        country_code: countryCode,
        address,
    });

    if (response.status === 200) {
        return response.data.success;
    }

    return false;
};

export const resetPasswordBookingWhizzMember = async (propertyId: string, email: string): Promise<any> => {
    const response = await axios.post<any>(`vendor-loyalty/${propertyId}/booking-whizz/password_reset `, {
        email,
    });

    if (response.status === 200) {
        return response.data.success;
    }

    return false;
};

export const getDialingCodes = (): string[] => [
    "+1",
    "+20",
    "+27",
    "+30",
    "+31",
    "+32",
    "+33",
    "+34",
    "+36",
    "+39",
    "+40",
    "+41",
    "+43",
    "+44",
    "+45",
    "+46",
    "+47",
    "+48",
    "+49",
    "+51",
    "+52",
    "+53",
    "+54",
    "+55",
    "+56",
    "+57",
    "+58",
    "+60",
    "+61",
    "+62",
    "+63",
    "+64",
    "+65",
    "+66",
    "+67",
    "+81",
    "+82",
    "+84",
    "+86",
    "+91",
    "+92",
    "+93",
    "+94",
    "+95",
    "+98",
    "+211",
    "+212",
    "+213",
    "+216",
    "+218",
    "+220",
    "+221",
    "+222",
    "+225",
    "+226",
    "+227",
    "+228",
    "+229",
    "+231",
    "+232",
    "+233",
    "+234",
    "+235",
    "+236",
    "+237",
    "+238",
    "+239",
    "+240",
    "+241",
    "+243",
    "+244",
    "+246",
    "+248",
    "+249",
    "+250",
    "+251",
    "+252",
    "+253",
    "+254",
    "+255",
    "+256",
    "+257",
    "+258",
    "+260",
    "+261",
    "+262",
    "+263",
    "+264",
    "+265",
    "+266",
    "+267",
    "+268",
    "+269",
    "+290",
    "+291",
    "+297",
    "+298",
    "+299",
    "+350",
    "+351",
    "+352",
    "+353",
    "+354",
    "+355",
    "+357",
    "+358",
    "+359",
    "+370",
    "+371",
    "+372",
    "+373",
    "+374",
    "+375",
    "+376",
    "+377",
    "+378",
    "+379",
    "+380",
    "+381",
    "+382",
    "+383",
    "+385",
    "+386",
    "+387",
    "+389",
    "+420",
    "+421",
    "+423",
    "+500",
    "+501",
    "+502",
    "+503",
    "+504",
    "+505",
    "+506",
    "+507",
    "+508",
    "+509",
    "+590",
    "+591",
    "+592",
    "+593",
    "+594",
    "+596",
    "+598",
    "+670",
    "+672",
    "+673",
    "+675",
    "+676",
    "+677",
    "+678",
    "+679",
    "+680",
    "+681",
    "+682",
    "+683",
    "+685",
    "+686",
    "+690",
    "+691",
    "+692",
    "+850",
    "+855",
    "+856",
    "+860",
    "+886",
    "+962",
    "+963",
    "+964",
    "+966",
    "+967",
    "+970",
    "+971",
    "+972",
    "+973",
    "+974",
    "+975",
    "+976",
    "+977",
    "+978",
    "+980",
    "+983",
    "+986",
    "+990",
    "+992",
    "+993",
    "+994",
    "+995",
    "+996",
    "+998",
    "+1264",
    "+1268",
    "+1284",
    "+1340",
    "+1345",
    "+1441",
    "+1473",
    "+1649",
    "+1664",
    "+1670",
    "+1671",
    "+1684",
    "+1721",
    "+1758",
    "+1767",
    "+1784",
    "+1787",
    "+1809",
    "+1829",
    "+1849",
    "+1868",
    "+1869",
    "+1876",
    "+1939",
    "+4779",
    "+5999",
];
